module.exports = __webpack_public_path__ + "static/LOGO-a566264650f2bd24ea41f4edb0750ddc.png";